import type { ReactNode } from "react";
import { cn } from "web-design-system";

/** The card strip that plan stat tiles sit on. */
export function StatsBar({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "bg-card flex rounded-lg px-4 py-5 justify-between items-center",
        className
      )}
    >
      {children}
    </div>
  );
}
